import { Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AccountSettingService } from 'src/app/Services/account-setting.service';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { HomePageService } from 'src/app/Services/home-page.service';
import { LoginUsersService } from 'src/app/Services/login-users.service';
import { MetaService } from 'src/app/Services/meta-data.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';
import Swal from 'sweetalert2';
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core/";
import { browserRefresh } from 'src/app/app.component';
import { ViewAdsPopupComponent } from './view-ads-popup/view-ads-popup.component';
import { MarketingService } from 'src/app/Services/marketing.service';
SwiperCore.use([Pagination, Navigation, Autoplay]);

@Component({
  selector: 'app-home-sections',
  templateUrl: './home-sections.component.html',
  styleUrls: ['./home-sections.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeSectionsComponent implements OnInit , OnDestroy {
    @ViewChild("newSwiper", { static: false }) newSwiper: any;
    @ViewChild("newSwiperLowSlides", { static: false }) newSwiperLowSlides: any;
    @Input('currentPageView') currentPageView:any;
    multiImages = [];
    smallSwiperConfig: any = {};
    bigSwiperConfig: any = {};
    loading: boolean = false;
    homePageData: any;
    homePageDataAds: any;
    homePageDataCustomAds: any;
    homePageDataSectionsSilders: any[] = [];
    homePageDataAdsShimmer: boolean = true;
    homePageDataCustomAdsShimmer: boolean = true;
    homePageDataSectionsSildersShimmer: boolean = true;
    homePageDataBrands: any;
    bannersCounter: number = 0;
    fakeArray = new Array(6);
    environmentVariables: any;
    categories: any = {
        clothing: [],
        shoes: [],
        accessories: [],
        gadgets: [],
    };
    isDirectionRtl = false;
    direction = "ltr";
    lang: any;
    fullDataSliderProducts: any[] = [];
    homePageDataSectionsSildersFull: any;
    innerWindowWidth: number = 0;
    sliderWidth: number = 0;
    scrollPosition: number = 0;
    areaSubscription: Subscription;
    branchSubscription: Subscription;
    brandsList:any=[];
    isSlider: boolean = true;
    flatProducts:any =[]
    bannerTypes = [
        { id: 0, name: "none" },
        { id: 1, name: "Product" },
        { id: 2, name: "Subcategory" },
        { id: 3, name: "Medical" },
        { id: 4, name: "Brand" },
        { id: 5, name: "Custom List" },
        { id: 6, name: "Category" },
        { id: 7, name: "Link" },
        { id: 8, name: "vendor" },
    ];
    constructor(
        public embryoService: EmbryoService,
        public translate: TranslateService,
        public homePageService: HomePageService,
        private router: Router,
        private auth: LoginUsersService,
        private metaService: MetaService,
        private account: AccountSettingService,
        private confgServ: StaticPagesService,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private marketingService: MarketingService,

    ) { 
        this.multiImages.length = 6;
        this.getInitilizingData();
        this.areaSubscription = this.auth.getAreaDataEmit().subscribe((res) => {
            this.getHomeSections();
            this.areaSubscription.unsubscribe();
        });

        this.branchSubscription = this.auth
            .getBranchDataEmit()
            .subscribe((res) => {
            this.getHomeSections();
            this.branchSubscription.unsubscribe();
        });

        if (
            this.environmentVariables &&
            this.environmentVariables?.PRODUCT_CARD_STYLE != "large"
        ) {
            this.smallSwiperConfig = {
                slidesPerView: 4,
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                    },
                    900: {
                        slidesPerView: 2.5,
                    },
                    500: {
                        slidesPerView: 2.5,
                    },
                    400: {
                        slidesPerView: this.environmentVariables
                            ?.SHOW_SECTIONS_AS_SLIDER
                            ? 2
                            : 1,
                        spaceBetween: 10,
                    },
                    300: {
                        slidesPerView: 1.5,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                draggable: true,
                navigation: true,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                pagination: false,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
            this.bigSwiperConfig = {
                slidesPerView: 6,
                draggable: true,
                breakpoints: {
                    1500: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    },
                    900: {
                        slidesPerView: 3.5,
                        spaceBetween: 10,
                    },
                    500: {
                        slidesPerView: 2.5
                    },
                    450: {
                        slidesPerView: this.environmentVariables
                            ?.SHOW_SECTIONS_AS_SLIDER
                            ? 2
                            : 1,
                        spaceBetween: 10,
                    },
                    400: {
                        slidesPerView: 2.1,
                        spaceBetween: 10,
                    },
                    300: {
                        slidesPerView: 2.1,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                navigation: true,
                pagination: false,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: false,
                responisve: true,
            };
        }
        else {
            this.smallSwiperConfig = {
                slidesPerView: 4,
                breakpoints: {
                    1500: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 2,
                    },
                    900: {
                        slidesPerView: 2,
                    },
                    500: {
                        slidesPerView: 2,
                    },
                    450: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                draggable: true,
                navigation: true,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                pagination: false,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
            this.bigSwiperConfig = {
                slidesPerView: 4,
                draggable: true,
                breakpoints: {
                    1500: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    500: {
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                    },
                    450: {
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                navigation: true,
                pagination: false,
                initialSlide: 0,
                slidesPerGroup: 1,
                centeredSlides: false,
                centeredSlidesBounds: true,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: true,
                responisve: true,
            };
        } 
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }
    
    ngOnInit() {
        if(browserRefresh && this.currentPageView === 'home/sections' && !this.environmentVariables?.enable_pop_up_ads_on_all_pages){
            this.getPopupAds();
        }
        this.lang = localStorage.getItem("lang");
        if (this.lang == "en") {
            this.metaService.setTitle(
                `${
                    this.environmentVariables?.sloganEn ||
                    this.environmentVariables?.APP_NAME
                }`
            );
            this.metaService.setDescription(
                `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                   `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
            );
        } 
        else {
            this.metaService.setTitle(
                `${
                    this.environmentVariables?.sloganAr ||
                    this.environmentVariables?.APP_NAME_AR
                }`
            );
            this.metaService.setDescription(
                `${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.metaDescriptionAr : 
                  `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.WEBSITE_URL}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.WEBSITE_URL}`
                }`
            );
        }

        this.bannersCounter = 0;
        this.translate.setDefaultLang(this.lang);
        this.getHomePageData();
        this.innerWindowWidth = window.innerWidth;

        this.embryoService.emitLang.subscribe((lang: string) => {
            if (lang && lang !== this.lang) {
                this.isDirectionRtl = lang === "en";
                this.translate.setDefaultLang(lang);
                this.getHomePageData();
                this.lang = lang;
                if (this.lang == "en") {
                    this.metaService.setTitle(
                        `${
                            this.environmentVariables?.sloganEn ||
                            this.environmentVariables?.APP_NAME
                        } `
                    );
                  this.metaService.setDescription(
                     `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                       `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
                    );
                } else {
                    this.metaService.setTitle(
                        `${
                            this.environmentVariables?.sloganAr ||
                            this.environmentVariables?.APP_NAME_AR
                        } `
                    );
               this.metaService.setDescription(
                 `${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.   metaDescriptionAr : 
                   `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.WEBSITE_URL}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.WEBSITE_URL}`
                  }`
               );
                }
            } else {
                this.direction = "rtl";
            }
        });
       
        this.embryoService.brandsList.subscribe(res=>{
            this.brandsList = res;   
        })
    }

    getHomePageData() {
        this.scrollPosition = window.pageYOffset;

        window.scroll(0, 0);

        this.loading = true;

        this.homePageService.loadingCategoriesEmit(true);
        this.homePageService.getHomeAdsData().subscribe({
            next: (rep) => {
                this.homePageDataAdsShimmer = false;
                if (rep.code === 200) {
                    this.homePageDataAds = rep.data;
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${rep.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
        });

        this.homePageService.getHomeCustomAdsData().subscribe({
            next: (rep) => {
                this.homePageDataCustomAds = rep.data;

                if (rep.code === 200) {
                    this.homePageDataCustomAdsShimmer = false;
                    if (
                        this.homePageDataSectionsSilders &&
                        this.homePageDataSectionsSilders.length
                    ) {
                        this.homePageDataSectionsSilders.forEach(
                            (element: any) => {
                                element["banners"] = this.dynamicBanners();
                            }
                        );
                    }
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${rep.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
        });

        this.homePageService.getHomeSectionsData(this.currentPageView).subscribe({
            next: (rep) => {
                this.homePageDataSectionsSildersShimmer = false;
                if (rep.code === 200) {
                    localStorage.setItem("sections", JSON.stringify(rep.data));
                    rep.data.forEach((element: any) => {
                        if (
                            this.homePageDataCustomAds &&
                            this.homePageDataCustomAds?.length
                        ) {
                            element["banners"] = this.dynamicBanners();
                        }
                        if (element?.products?.length) {
                            element.have_products = true;
                            element.list_categories = [];
                            if (element.products.length > 0) {
                                if (element.products.length == 1 && this.environmentVariables.ENABLE_PRODUCTS_LOOP_IN_SECTION) {
                                    element.products = element.products.concat(
                                        element.products
                                    );
                                }
                            }
                            element.products.forEach((product: any) =>
                                element.list_categories.push(
                                    product.category
                                        ? product.category.name
                                        : ""
                                )
                            );

                            let arr: {
                                item_name: any;
                                item_id: any;
                                price: any;
                                item_brand: any;
                                item_category: any;
                                item_category2: any;
                                item_list_name: any;
                                item_list_id: any;
                                index: number;
                            }[] = [];
                            element.products.forEach(
                                (product: any, index: number) => {
                                    let obj = {
                                        item_name: product.name,
                                        item_id: product.id,
                                        price: product.discount_price
                                            ? product.discount_price
                                            : product.price,
                                        item_brand:
                                            product.details &&
                                            product.details.brand
                                                ? product.details.brand.name
                                                : "",
                                        item_category: product.category
                                            ? product.category.name
                                            : "",
                                        item_category2: product.category
                                            ? product.category.sub_categories[0]
                                                  .name
                                            : "",
                                        item_list_name: product.actegory
                                            ? product.actegory.id
                                            : "",
                                        item_list_id: product.actegory
                                            ? product.actegory.name
                                            : "",
                                        index: index + 1,
                                    };
                                    arr.push(obj);
                                }
                            );
                            let result = {
                                event: "view_item_list",
                                ecommerce: {
                                    items: arr,
                                    extras: this.account
                                        .googleAnalaticsUserData,
                                },
                            };
                        } else {
                            element.have_products = false;
                        }
                    });
                    this.cretaeProductSectionsSchema(rep.data)
                    this.homePageDataSectionsSilders = rep.data;
                    this.homePageDataSectionsSildersFull =
                    this.homePageDataSectionsSilders;
                    this.loading = false;
                } 
                else {
                    Swal.fire({
                        html: `<p style='color:white'>${rep.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
        });
    }
      
    cretaeProductSectionsSchema(data:any){
        if (data) {
            this.flatProducts = data.flatMap((item:any) => item.products);
        }

        for (let index = 0; index < this.flatProducts.length; index++) {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = `
                {
                    "@context": "https://schema.org",
                    "@type": "Product",
                    "name": "${this.flatProducts[index].name ? this.flatProducts[index]?.name : 'product name'}",
                    "description": "${this.flatProducts[index].name}",
                    "image": "${this.flatProducts[index]?.image}",
                    "offers": [
                        {
                            "@type": "Offer",
                            "priceCurrency": "${this.environmentVariables.CURRENCY_CODE_EN}",
                            "price": ${this.flatProducts[index].discount_price   ? this.flatProducts[index].discount_price : this.flatProducts[index]?.price},
                            "seller": {
                                "@type": "Organization",
                                "name": "${this.environmentVariables.APP_NAME}"
                            },
                            "url": "${this.flatProducts[index]?.share_link}",
                            "sku": "${this.flatProducts[index]?.sku}",
                            "mpn": "${this.flatProducts[index]?.sku}"
                        }
                    ],
                    "url": "${this.flatProducts[index]?.share_link}",
                    "manufacturer": {
                        "@type": "Organization",
                        "name": "${this.flatProducts[index]?.brand ? this.flatProducts[index]?.brand?.name : ''}"
                    },
                    "sku": "${this.flatProducts[index]?.sku}",
                    "mpn": "${this.flatProducts[index]?.sku}"
                }
            `;
            document.body.appendChild(script);
        }
    }

    getHomeSections() {
        this.homePageService.getHomeSectionsData(this.currentPageView).subscribe({
            next: (rep) => {
                this.homePageDataSectionsSildersShimmer = false;
                if (rep.code === 200) {
                    localStorage.setItem("sections", JSON.stringify(rep.data));
                    
                    rep.data.forEach((element: any) => {
                        if (
                            this.homePageDataCustomAds &&
                            this.homePageDataCustomAds?.length
                        ) {
                            element["banners"] = this.dynamicBanners();
                        }
                        if (element?.products?.length) {
                            element.have_products = true;
                            element.list_categories = [];
                            element.products.forEach((product: any) =>
                                element.list_categories.push(
                                    product.category
                                        ? product.category.name
                                        : ""
                                )
                            );

                            let arr: {
                                item_name: any;
                                item_id: any;
                                price: any;
                                item_brand: any;
                                item_category: any;
                                item_category2: any;
                                item_list_name: any;
                                item_list_id: any;
                                index: number;
                            }[] = [];
                            element.products.forEach(
                                (product: any, index: number) => {
                                    let obj = {
                                        item_name: product.name,
                                        item_id: product.id,
                                        price: product.discount_price
                                            ? product.discount_price
                                            : product.price,
                                        item_brand:
                                            product.details &&
                                            product.details.brand
                                                ? product.details.brand.name
                                                : "",
                                        item_category: product.category
                                            ? product.category.name
                                            : "",
                                        item_category2: product.category
                                            ? product.category.sub_categories[0]
                                                    .name
                                            : "",
                                        item_list_name: product.actegory
                                            ? product.actegory.id
                                            : "",
                                        item_list_id: product.actegory
                                            ? product.actegory.name
                                            : "",
                                        index: index + 1,
                                    };
                                    arr.push(obj);
                                }
                            );
                            let result = {
                                event: "view_item_list",
                                ecommerce: {
                                    items: arr,
                                    extras: this.account
                                        .googleAnalaticsUserData,
                                },
                            };
                        } else {
                            element.have_products = false;
                        }
                    });
                    this.homePageDataSectionsSilders = rep.data;
                    this.homePageDataSectionsSildersFull =
                        this.homePageDataSectionsSilders;
                    this.loading = false;
                }
                else {
                    Swal.fire({
                        html: `<p style='color:white'>${rep.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
        });
    }

    bannerRouting(slide: any, indexSection = 0, indexImage= 0) {
        if (slide.type === 0 || slide.type === null) {
            return;
        }
        else if (slide.type === 1) {
            this.router.navigateByUrl(
                "/" +
                    this.lang +
                    `/products/` +
                    (slide.link
                        ? slide.link
                        : slide.name +
                          "/" +
                          slide.item_id +
                          "?variant=" +
                          slide.item_id)
            );
        }
        else if ((slide.type > 1 && slide.type <= 6) || slide.type == 9 || slide.type == 8) {
            const queryParams: any = {};
            if (slide.type === 2) {
                queryParams.sub_category_id = slide.item_id;
            }
            if (slide.type === 4) {
                queryParams.brand_id = slide.item_id;
            }
            if (slide.type === 5) {
                queryParams.list_ids = slide.item_id;
            }
            if (slide.type === 6) {
                queryParams.category_id = slide.item_id;
            }
            if (slide.type === 8) {
                queryParams.group_id = slide.item_id;
            }
            if (slide.type === 9) {
                queryParams.vendor_ids = slide.item_id;
            }
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        }
        else {
            if (slide.type === 7 && !slide.extrnal) {
                window.open(slide.link, "_self");
            } else {
                window.open(slide.link, "_blank");
            }
        }
        this.onGA4PromotionClickEvent(slide, indexSection, indexImage)

    }

    onGA4PromotionClickEvent(data:any,indexSection= 1, indexImage = 1){
        console.log('data', data)
        // console.log('index', this.index)
        let data_refactor = {
            promotion_id:data.id ?? null,
            promotion_name:data.name ?? null,
            promotion_position:`${indexSection+2}.${indexImage+1}`, // increase 2 in index number to sort section number   
            promotion_type:this.bannerTypes.filter((item:any) => item.id === data.type)[0].name,
        }
        console.log('data_refactor',data_refactor )
        this.marketingService.GA4PromotionClickEvent(data_refactor)
    }

    dynamicBanners() {
        if (this.bannersCounter == 0) {
            this.bannersCounter += 6;
        } else {
            this.bannersCounter += 5;
        }
        return this.homePageDataCustomAds.slice(
            this.bannersCounter,
            this.bannersCounter + 5
        );
    }

    public getBgImage(product: any) {
        const bgImage = {
            "background-image":
                product != null
                    ? "url(" + product.image + ")"
                    : "url(https://via.placeholder.com/600x400/ff0000/fff/)",
        };
        return bgImage;
    }

    filterProductsCardSlider(x: any, dataSelect: any) {
        dataSelect.list_products = [];
        if (x == "All") {
            const ProductIndex = this.homePageDataSectionsSildersFull.findIndex(
                (item: any) => item.id == dataSelect.id
            );
            if (ProductIndex !== -1) {
                dataSelect.list_products =
                    this.homePageDataSectionsSildersFull[ProductIndex].products;
            }
        } else {
            const ProductIndex = this.homePageDataSectionsSildersFull.findIndex(
                (item: any) => item.id == dataSelect.id
            );
            if (ProductIndex !== -1) {
                this.homePageDataSectionsSildersFull[
                    ProductIndex
                ].products.forEach((product: any) => {
                    if (product.category.name == x) {
                        dataSelect.list_products.push(product);
                    }
                });
            }
        }
        dataSelect.products = dataSelect.list_products;
    }

    public addToCart(value: any) {
        this.embryoService.addToCartGuest(value);
    }

    public addToWishlist(value: any) {
        this.embryoService.addToWishlist(value);
    }

    encodeName(name: string) {
        return encodeURIComponent(name.replace(/\s/g, "-"));
    }

    setWindowScroll() {
        setTimeout(() => {
            /*set scroll position after get data*/
            window.scroll(0, this.scrollPosition);
        }, 0);
    }

    floatingBannerRouting(index: number) {
        const floatingBanner = this.homePageDataCustomAds[index];
        if (floatingBanner.item_data) {
            floatingBanner.nameRouter = encodeURIComponent(
                floatingBanner.item_data.name_en.replace(/\s/g, "-")
            );
        }
        const type = floatingBanner.type;
        if (type === 0) {
            return;
        } else if (type === 1) {
            this.router.navigateByUrl(
                `/${this.lang}/products/${this.homePageDataCustomAds[index].link}`
            );
        } else if (type > 1 && type <= 6) {
            const queryParams: any = {};
            if (type === 2) {
                queryParams.sub_category_id = floatingBanner.item_id;
            }
            if (type === 4) {
                queryParams.brand_id = floatingBanner.item_id;
            }
            if (type === 5) {
                queryParams.list_ids = floatingBanner.item_id;
            }
            if (type === 6) {
                queryParams.category_id = floatingBanner.item_id;
            }

            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            if (type === 7 && floatingBanner.extrnal) {
                window.open(floatingBanner.link, "_self");
            } else {
                window.open(floatingBanner.link, "_blank");
            }
        }
    }

    navigateToLink(item: any) {
        if (item.link_en) {
            window.open(item.link_en, "_self");
        }
    }

    load(list: any): void {
        this.router.navigate(["/" + this.lang + "/products"], {
            queryParams: {
                list_ids: list?.list_id,
                name_en: list?.name_en,
                name_ar: list?.name_ar,
            },
        });
    }

    ngOnDestroy() {
        this.areaSubscription.unsubscribe();
        this.branchSubscription.unsubscribe();
    }

    getImageName(imageSrc :any) {
        if(imageSrc){
        var imageSrcParts = imageSrc?.split('/');
        var imageName = imageSrcParts[imageSrcParts?.length - 1];
        return imageName;
        }
    }

    getPopupAds() {
        this.homePageService.getHomePopupAdsData().subscribe((res: any) => {
            let popupImageIndex: any = localStorage.getItem('popupImageIndex');
            
            
             if (popupImageIndex === null) {
                // First time visiting the page, set the initial index to 0
                popupImageIndex = 0;
            }
            else {
                 popupImageIndex = +popupImageIndex; // Convert the index from string to number
              }
             if (popupImageIndex < res?.data?.length - 1) {
                popupImageIndex++; // Increment the index if it's within bounds
            }
            else {
                popupImageIndex = 0; // Reset the index to 0 to start from the beginning
            }
            localStorage.setItem('popupImageIndex', popupImageIndex.toString()); // Save the updated index
            res.data?.length > 0 ? this.viewAdsPopup(res.data) : '';
        });
    }

    viewAdsPopup(data: any) {
        let dialogRef:any;
        dialogRef = this.dialog.open(ViewAdsPopupComponent, { panelClass: 'custom-dialog-container' ,
            data: data,
        });
        dialogRef.afterClosed().subscribe();
    }
}
